/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2023
 * @format
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import PopupHeader from '../../../Fireboard/components/PopupHeader';
import FireboardUtils from '../../../../util/fireboard-util';
import strings from '../../../../globalization';
import classes from './CheckSelection.module.css';

const CheckSelection = ({ onClosePopup, data }) => {
  const { currencyInfo } = useSelector(state => state);
  const { currency } = currencyInfo || {};

  return (
    <div className={classes.container}>
      <PopupHeader title={strings.selectACheck} onClose={onClosePopup} />
      <div className={classes.contentWrapper}>
        <table className={classes.table}>
          <TableHeader />
          <TableBody data={data} currency={currency} />
        </table>
      </div>
      <div className={classes.btnsWrapper}>
        <Button className={classes.allActionBtn} onClick={() => data?.allAction(data?.list)}>
          <span className={classes.allActionBtnTxt}>{data?.allActionText}</span>
        </Button>
      </div>
    </div>
  );
};

export default CheckSelection;

CheckSelection.propTypes = {
  onClosePopup: PropTypes.func,
  data: PropTypes.object,
};

CheckSelection.defaultProps = {
  onClosePopup: () => { },
  data: {},
};

const TableHeader = () => {
  return (
    <thead>
      <tr>
        <th>{strings.checkNumber}</th>
        <th>{strings.tableNumber}</th>
        <th>{strings.employee}</th>
        <th>{strings.checkHistoryOpen}</th>
        <th>{strings.close}</th>
        <th>{strings.checkHistoryTotal}</th>
        <th></th>
      </tr>
    </thead>
  );
};

const TableBody = ({ data, currency }) => {
  const { list, actionText, eachAction } = data || {};
  const checks = Array.isArray(list) ? list : [];

  return (
    checks.map(eachCheck => (
      <tbody key={`id-${eachCheck.id}`}>
        <tr>
          <td>{eachCheck?.checkNumber}</td>
          <td>{eachCheck?.stationNumber}</td>
          <td>{eachCheck?.employeeFirstName} {eachCheck?.employeeLastName}</td>
          <td>{FireboardUtils.getTimeInHrsMins(eachCheck?.openDate)}</td>
          <td>{FireboardUtils.getTimeInHrsMins(eachCheck?.closeDate)}</td>
          <td>{currency}{eachCheck?.totalAmount}</td>
          <td>
            <Button className={classes.actionBtn} onClick={() => eachAction && eachAction(eachCheck)}>
              <span className={classes.actionBtnTxt}>{actionText}</span>
            </Button>
          </td>
        </tr>
      </tbody>
    ))
  );
};
